// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"47398881","123":"bf0622ec","495":"78f7f632"}[chunkId] + ".chunk.css";
};